<template>
    <div class="app-articles">
        <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>

        <div class="container my-5">
            <div class="row my-5 articles-card" v-if="contentLoaded">
                <div class="col-12 col-md-4 mb-3" v-for="(article, i) in articles" :key="i">
                    <article-card 
                        :created_by="article.created_by"
                        :date_created="article.date_created"
                        :title="article.title"
                        :content="article.content"
                        :mask="article.mask"
                        :dash="article.dash"
                        :date_link="article.date_link"
                    />
                </div>

            </div>

            <div v-if="!contentLoaded" class="row">
                <div class="col-12 col-md-4 mb-3" v-for="(fake, i) in fakeItems" :key="i">
                    <fake-article-card></fake-article-card>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    let heroImage = require('@/assets/img/hero/news.jpg');
    import TopHero from '@/components/frontend/Hero.vue'
    import ArticleCard from '@/components/frontend/articles/Articles.vue'
    import FakeArticleCard from '@/components/frontend/content_placeholders/Articles.vue'
    import axios from 'axios'

    export default {
        components: {
            TopHero: TopHero, 
            ArticleCard: ArticleCard,
            FakeArticleCard: FakeArticleCard
        },
        name: 'Index',
        data() {
            return {
                heroImage: heroImage,
                title: 'News & Articles',
                articles: [],
                contentLoaded: false,
                fakeItems: 3
            }
        },
        methods: {
            fetchData() {
                axios.get(APIURL + 'articles')
                .then((response) => {
                    this.contentLoaded = true;
                    let res = response.data;

                    this.articles = res.data;
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        created() {
            this.fetchData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/frontend/article/Index.vue